import {  Component, computed, inject } from '@angular/core';
import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { AppService } from '@app/core/services/app.service';
import { Router } from '@angular/router';
import { NavigationItem } from '@app/shared/models/navigation-item';
import { StationFacade } from '@app/station/station.facade';
import { map, Observable, of } from 'rxjs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationMenuComponent } from './navigation-menu/navigation-menu.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-side-nav',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [
      MatToolbarModule,
      MatIconModule,
      UpperCasePipe,
      MatSidenavModule,
      AsyncPipe,
      TranslateModule,
      NavigationMenuComponent,
      MatButtonModule
    ],
    standalone: true
})
export class NavigationComponent {
  private readonly appService = inject(AppService);
  private readonly router = inject(Router);
  private readonly stationFacade = inject(StationFacade);
  private readonly acceptedEulaSignal = this.appService.acceptedEulaSignal;

  protected readonly selectedChildSignal = this.appService.selectedChild;
  protected readonly bottomNavElements: NavigationItem[] = [
    new NavigationItem('home', '/exhibition/6991dd88a3b6485a8698cbee/tour/6992de66a3b6485a8698e12c/station', 'Home', 'Home'),
    new NavigationItem('lexikon', '/lexicon', 'Wissen A-Z', 'WissenAZ'),
    new NavigationItem('templates', '/exhibition/6991dd88a3b6485a8698cbee/tour/6992de66a3b6485a8698e12c/station/699f392aa3b6485a869a9ff9', 'Tipps +', 'Tipps'), // '699f392aa3b6485a869a9ff9'
    new NavigationItem('contact', '/favorites', 'Merkliste', 'Merkliste')
  ]


  protected get url(): string {
    return this.router.url;
  }

  protected get isNotBaseUrl(): boolean {
    return !this.router.url.endsWith('/');
  }

  protected get isNotPersonalization(): boolean {
    return !this.router.url.endsWith('/personalization');
  }

  protected readonly isNotInstructionOnFirstRun = computed (() => {
    return !this.router.url.endsWith('/personalization') && this.acceptedEulaSignal();
  });

  protected get hideBackButtonOnSomeRoutes() {
    return this.router.url.endsWith('language-selection')
           || this.router.url.endsWith('/');
  }

  protected navigateToRoute(route: string) {
    this.router.navigate([route]);
  }

  get title(): Observable<string> {
    const pageTitle = this.appService.getPageTitle(this.router.url);

    if (pageTitle) {
      return of(pageTitle);
    } else {
      if (this.router.url.includes('/substation/')) {
        return of('Tipp');
      } else if (this.router.url.includes('station/')) {
        const splitUrl = this.router.url.split('/station/');
        return this.stationFacade.getStationById(splitUrl[splitUrl.length - 1])
        .pipe(
          map(substation => {
            return substation?.title['de'];
          })
        );
      }

      return of('');
    }
  }

  protected get showIcon(): boolean {
    return this.router.url.endsWith("station")
      || this.router.url.endsWith("about")
      || this.router.url.endsWith("imprint")
      || this.router.url.endsWith("instruction");
  }

  protected get isFullscreen(): boolean {
    return this.router.url.endsWith('/station')
      || this.router.url.includes('/forum');
  }

  protected get isOnHotspotScreen(): boolean {
    return this.router.url.endsWith('/station');
  }

  protected get isOnStationListScreen(): boolean {
    return (this.router.url.includes('/station/') && !this.router.url.includes('/substation/'))
      || this.router.url.endsWith('/favorites');
  }

  protected onClickChild() {
    this.router.navigateByUrl('child-admin');
  }
}
